import { render, staticRenderFns } from "./Simple.vue?vue&type=template&id=eb833f64&scoped=true&"
import script from "./Simple.vue?vue&type=script&lang=ts&"
export * from "./Simple.vue?vue&type=script&lang=ts&"
import style0 from "./Simple.vue?vue&type=style&index=0&id=eb833f64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb833f64",
  null
  
)

export default component.exports